var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edition-badge",class:_vm.cssClass},[_c('div',{staticClass:"edition-badge-name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }